import { ITableColumn } from "../../../../App/Typings/Table";
import { useGetAbacAppsQuery } from "../../AbacAppQueries";
import useCreateAppFormState from "./CreateAppFormState";

export default function useAbacAppState() {
  const createAppModalTitle = "Create New ABAC Application";
  const { data: apps = [], isLoading } = useGetAbacAppsQuery();
  const {
    getters: { createIsLoading, formik },
    handlers: { handleCreateModalClose },
  } = useCreateAppFormState();

  const columns: ITableColumn[] = [
    { label: "Application Name", propName: "name" },
    { label: "Tech Stack", propName: "techStack" },
    { label: "Last Updated", propName: "updatedDate" },
    { label: "Date Created", propName: "createdDate" },
    { label: "Is Active", propName: "isActive" },
  ];

  return {
    getters: {
      apps,
      columns,
      isLoading,
      createAppModalTitle,
      createIsLoading,
      formik,
    },
    handlers: { handleCreateModalClose },
  };
}
